import React, { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setSearchTerm, setFilterTerm } from '../redux/slices/appSlice';

// Per-tab table filter input. With a `tabKey` it reads/writes
// state.app.filterTerms[tabKey] — a per-tab term that narrows that tab's
// rows. Currently only the Library tab renders one; the tool tabs
// deliberately have no text filter (their scoping lives in the source picker
// and the status/type/LUFS filters, which also scope their runs). Terms are
// per-tab by design: a filter typed in one tab must never invisibly hide
// rows in another. Cmd+F (FindOverlay) is the separate highlight-only search
// and shares no state with this box.
// Without tabKey it falls back to the legacy shared state.app.searchTerm.
const TabFilterBox = ({ placeholder = 'Filter...', fullWidth = false, tabKey = null }) => {
    const sharedTerm = useSelector((state) => state.app.searchTerm);
    const tabTerm = useSelector((state) => (tabKey ? state.app.filterTerms[tabKey] : undefined));
    const term = tabKey ? (tabTerm || '') : sharedTerm;
    const dispatch = useDispatch();
    const inputRef = useRef(null);

    const write = (value) => {
        if (tabKey) dispatch(setFilterTerm({ tab: tabKey, term: value }));
        else dispatch(setSearchTerm(value));
    };

    return (
        <div className={`tab-filter-box${fullWidth ? ' full-width' : ''}`}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className="tab-filter-icon">
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
            </svg>
            <input
                ref={inputRef}
                type="text"
                className="tab-filter-input"
                placeholder={placeholder}
                value={term}
                onChange={(e) => write(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Escape') {
                        write('');
                        inputRef.current?.blur();
                    }
                }}
            />
            {term && (
                <button
                    type="button"
                    className="tab-filter-clear"
                    aria-label="Clear filter"
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => {
                        write('');
                        inputRef.current?.focus();
                    }}
                >
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </button>
            )}
        </div>
    );
};

export default TabFilterBox;
